import * as Yup from 'yup';

import { Strings } from '@app/constants';

export const addRoleSchema = Yup.object()
  .shape({
    name: Yup.string().trim().required(Strings.validation.fieldRequired(Strings.field.roleName)),
    permission: Yup.object().optional(),
  })
  .required();
